import { Table, Image } from "antd";

import DeleteModal from "../DeleteMaster";
import AddEditMaster from "../AddEditMaster";
import { Actions, ModuleAndIdMapping, Modules } from "../../../constants/DatabaseConstants/MasterConstant";
import Loading from "../../common/Loading";

import { DisplayMasterProps } from "../../../shared/interface/MasterManagement/masterManagementCommon.interface";
import { useDisplayMaster } from "./index.hook";

const DisplayMaster = (props: DisplayMasterProps) => {
  const config = useDisplayMaster(props);

  return (
    <>
      {config.loading && <Loading />}

      {!config.loading && config.masterFilters?.moduleId !== ModuleAndIdMapping[Modules.WEB_FE_ACCESS_CONTROL_MASTER] && (
        <Table //
          className="gx-table-responsive"
          size="small"
          columns={config.columns}
          dataSource={config.filteredTableData}
          pagination={config.pagination}
          onChange={config.handleChangePagination}
          bordered
          rowKey={(record) => record.sr_no}
        />
      )}

      {/* delete record */}
      {config.rowId && config.actionType === Actions.DELETE && (
        <DeleteModal //
          rowId={config.rowId}
          moduleId={config.masterFilters?.moduleId!}
          rowData={config.rowData}
          handleEnableRefresh={config.handleEnableRefresh}
          handleClearRowIdAndActionType={config.handleClearRowIdAndActionType}
        />
      )}

      {/* add/edit record */}
      {(props.addRecord || (config.rowId && config.actionType === Actions.EDIT) || props.bulkEditRecord) && (
        <AddEditMaster //
          rowId={config.rowId}
          rowData={config.rowData}
          moduleId={config.masterFilters?.moduleId!}
          addRecord={props.addRecord}
          handleEnableRefresh={config.handleEnableRefresh}
          handleAddRecord={props.handleAddRecord}
          handleClearRowIdAndActionType={config.handleClearRowIdAndActionType}
          handleBulkEditRecord={props.handleBulkEditRecord}
          bulkEditRecord={props.bulkEditRecord}
        />
      )}

      {/* Preview Image */}
      <Image
        width={200}
        style={{ display: "none" }}
        src={config.imagePreview!}
        onError={config.handleImageError}
        preview={{
          visible: config.visible,
          src: config.imagePreview!,
          onVisibleChange: (value) => {
            config.setVisible(value);
            config.handleResetImagePath();
          }
        }}
      />
    </>
  );
};

export default DisplayMaster;
